import script from "./PopupNotificationsSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./PopupNotificationsSetting.vue?vue&type=script&lang=ts&setup=true"

import "./PopupNotificationsSetting.vue?vue&type=style&index=0&id=1bc92aa8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bc92aa8"]])

export default __exports__